"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ProductTranslationReducer = exports.ProductReducer = undefined;

var _apiCategoryProducts_post = require("../actions/esdb/apiCategoryProducts_post");

var _apiProduct = require("../actions/esdb/apiProduct");

var _apiProductsFeatured = require("../actions/esdb/apiProductsFeatured");

var _apiElasticsearch_search_post = require("../actions/esdb/apiElasticsearch_search_post");

var _apiManufacturerProductOverview_post = require("../actions/esdb/apiManufacturerProductOverview_post");

var _apiProductPromotionOverview_post = require("../actions/esdb/apiProductPromotionOverview_post");

var _apiCategoryPlaceProducts_post = require("../actions/esdb/apiCategoryPlaceProducts_post");

var _apiProductsNewest_post = require("../actions/esdb/apiProductsNewest_post");

var _apiProduct_post = require("../actions/esdb/apiProduct_post");

var _translate = require("@esnpm/translate");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _apiV2ProductsGet_post = require("../actions/esdb/apiV2ProductsGet_post");

var _FilterClasses = require("../components/product/FilterClasses");

var _apiStockMovementPlanningProducts = require("../actions/esdb/apiStockMovementPlanningProducts");

var _apiProductSelectedSupplierPurchaseUnit_post = require("../actions/esdb/apiProductSelectedSupplierPurchaseUnit_post");

var _apiProductSelectedSupplierPurchaseUnit_delete = require("../actions/esdb/apiProductSelectedSupplierPurchaseUnit_delete");

var _apiProductStock_post = require("../actions/esdb/apiProductStock_post");

var _apiStockMovementPlanningProduct = require("../actions/esdb/apiStockMovementPlanningProduct");

var _apiProductStockStocktaking_post = require("../actions/esdb/apiProductStockStocktaking_post");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EmbeddedDocumentLists = {
	"STOCK": "STOCK_ID",
	"SUPPLIERS": "SUPPLIER_ID",
	"SELLING_PLATFORMS": "SELLING_PLATFORM"
};

var ProductMergeWithCustomizer = function ProductMergeWithCustomizer(objValue, srcValue, key) {
	if (_lodash2.default.isArray(objValue)) {
		if (_lodash2.default.get(EmbeddedDocumentLists, key, null) != null) {
			return Object.values(_lodash2.default.assign({}, _lodash2.default.keyBy(objValue, function (i) {
				return i[EmbeddedDocumentLists[key]];
			}), _lodash2.default.keyBy(srcValue, function (i) {
				return i[EmbeddedDocumentLists[key]];
			})));
		}
		return _lodash2.default.unionWith(objValue, srcValue, _lodash2.default.isEqual);
	}
};

var ProductReducer = exports.ProductReducer = function ProductReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	switch (action.type) {
		case _apiProduct.API_PRODUCT_FAILURE:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.payload.error.ERROR, action.payload));

		case _apiProduct.API_PRODUCT_REQUEST:
		case _apiProduct_post.API_PRODUCT_POST_REQUEST:
		case _apiProductStockStocktaking_post.API_PRODUCT_STOCK_STOCKTAKING_POST_REQUEST:
			return _lodash2.default.merge({}, state, _defineProperty({}, action.options.SKU, action.payload));

		case _apiProduct.API_PRODUCT_SUCCESS:
		case _apiCategoryProducts_post.API_CATEGORY_PRODUCTS_POST_SUCCESS:
		case _apiCategoryPlaceProducts_post.API_CATEGORY_PLACE_PRODUCTS_POST_SUCCESS:
		case _apiProductsFeatured.API_PRODUCTS_FEATURED_SUCCESS:
		case _apiElasticsearch_search_post.API_ELASTICSEARCH_SEARCH_POST_SUCCESS:
		case _apiManufacturerProductOverview_post.API_MANUFACTURER_PRODUCT_OVERVIEW_POST_SUCCESS:
		case _apiProductPromotionOverview_post.API_PRODUCT_PROMOTION_OVERVIEW_POST_SUCCESS:
		case _apiProductsNewest_post.API_PRODUCTS_NEWEST_POST_SUCCESS:
		case _apiProduct_post.API_PRODUCT_POST_SUCCESS:
		case _apiV2ProductsGet_post.API_PRODUCTS_GET_POST_SUCCESS:
		case _apiStockMovementPlanningProducts.API_STOCK_MOVEMENT_PLANNING_PRODUCTS_SUCCESS:
		case _apiStockMovementPlanningProduct.API_STOCK_MOVEMENT_PLANNING_PRODUCT_SUCCESS:
		case _apiProductSelectedSupplierPurchaseUnit_delete.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_DELETE_SUCCESS:
		case _apiProductSelectedSupplierPurchaseUnit_post.API_PRODUCT_SELECTED_SUPPLIER_PURCHASE_UNIT_POST_SUCCESS:
		case _apiProductStock_post.API_PRODUCT_STOCK_POST_SUCCESS:
		case _apiProductStockStocktaking_post.API_PRODUCT_STOCK_STOCKTAKING_POST_SUCCESS:
		case "API_PRODUCTS_SUCCESS":

			var timesStamp = new Date().getTime();
			var reduced = action.payload.data.PRODUCTS.reduce(function (obj, item) {
				var filterClass = state[item.SKU] != undefined ? Object.assign({}, state[item.SKU].filterClass) : {};

				_FilterClasses.filterClasses[action.payload.data.FILTER_CLASS].map(function (entry) {
					return filterClass[entry] = timesStamp;
				});
				obj[item.SKU] = {
					loading: action.payload.loading,
					error: action.payload.error,
					data: item,
					filterClass: filterClass
				};
				return obj;
			}, {});
			// const merged = _.merge({}, state, reduced);
			var merged = _lodash2.default.mergeWith({}, state, reduced, ProductMergeWithCustomizer);
			var overWritePathes = ["FLAGS", "DATA_COMPATIBILITY", "REQUESTED_DATA_COMPATIBILITY", "TEXTS.NAME_TEXT", "TEXTS.SHORT_TEXT", "TEXTS.LONG_TEXT", "SUPPLIERS"];
			var pick = null;
			var newSKUData = {};
			Object.keys(reduced).map(function (sku) {
				pick = _lodash2.default.pick(reduced[sku].data, overWritePathes);
				newSKUData = _lodash2.default.assign({}, merged[sku].data, pick);
				merged[sku].data = newSKUData;
			});
			return merged;

		default:
			return state;
	}
};

var ProductTranslationReducer = exports.ProductTranslationReducer = function ProductTranslationReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _translate.TranslationReducer_InitialState;
	var action = arguments[1];

	switch (action.type) {
		case _apiCategoryProducts_post.API_CATEGORY_PRODUCTS_POST_SUCCESS:
		case _apiProduct.API_PRODUCT_SUCCESS:
		case _apiProductsFeatured.API_PRODUCTS_FEATURED_SUCCESS:
		case _apiElasticsearch_search_post.API_ELASTICSEARCH_SEARCH_POST_SUCCESS:
		case _apiManufacturerProductOverview_post.API_MANUFACTURER_PRODUCT_OVERVIEW_POST_SUCCESS:
		case _apiProductPromotionOverview_post.API_PRODUCT_PROMOTION_OVERVIEW_POST_SUCCESS:
		case _apiStockMovementPlanningProducts.API_STOCK_MOVEMENT_PLANNING_PRODUCTS_SUCCESS:
		case _apiStockMovementPlanningProduct.API_STOCK_MOVEMENT_PLANNING_PRODUCT_SUCCESS:
		case _apiProductsNewest_post.API_PRODUCTS_NEWEST_POST_SUCCESS:
		case "API_PRODUCTS_SUCCESS":

			return (0, _translate.registerTranslation)(Object.assign({}, state), ["products"], action.payload.data.PRODUCTS.reduce(function (obj, item) {
				obj[item.SKU] = item.TEXTS;
				return obj;
			}, {}));
		default:
			return state;
	}
};